import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = {
  key: 0,
  class: "symbol"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  src: "/img/pokercards/sheet.png"
}

import TournamentParticipantPokerCombinationDTO from "@/models/TournamentParticipantPokerCombinationDTO";
import {computed} from "vue";

interface Card {
  symbol: string
  suit: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PokerCombination',
  props: {
    pokerCombination: {}
  },
  setup(__props: any) {

const props = __props

const SYMBOL_MAP = {1: 'A', 11: 'J', 12: 'Q', 13: 'K'} as any;
const SUITS_MAP = {'C': 'clubs', 'H': 'hearts', 'D': 'diamonds', 'S': 'spades'} as any;

const cards = (pokerCombination: TournamentParticipantPokerCombinationDTO|null): Card[] => {
  const openCards = pokerCombination?.openCards ?? [];
  let cards = [] as Card[];
  for (const card of openCards) {
    const parts = card.split(':');
    const symbolIndex = parts[0];
    const suitIndex = parts[1];

    cards.push({
      symbol: SYMBOL_MAP[symbolIndex] ?? symbolIndex,
      suit: SUITS_MAP[suitIndex]
    } as Card)
  }

  for (let i = cards.length; i < 5; i++) {
    cards.push({
      symbol: '',
      suit: 'sheet'
    } as Card)
  }

  return cards;
}

const fogHeight = computed(() => {
  if (!props.pokerCombination) {
    return '100%';
  }

  const percent = 100 - parseFloat(props.pokerCombination.currentCardProgress) * 100
  return percent + '%';
})

const fogIndex = computed(() => {
  if (!props.pokerCombination) {
    return -1;
  }

  return props.pokerCombination.openCards.length;
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards(props.pokerCombination), (card, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["poker-card", card.suit])
      }, [
        (card.suit !== 'sheet')
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(card.symbol), 1))
          : _createCommentVNode("", true),
        (card.suit !== 'sheet')
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "suit",
              src: `/img/pokercards/${card.suit}.svg`
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createElementBlock("img", _hoisted_4)),
        (card.suit === 'sheet')
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "fog",
              style: _normalizeStyle({height: index === fogIndex.value ? fogHeight.value : '100%'})
            }, null, 4))
          : _createCommentVNode("", true)
      ], 2))
    }), 256))
  ]))
}
}

})